'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var FILTER = 'M1.7998 5.3999H21.7998V7.3999H1.7998V5.3999ZM5.79967 13.3999V11.3999H17.7997V13.3999H5.79967ZM9.79993 17.3999V19.3999H13.7999V17.3999H9.79993Z';
var IconFilter = lib.variant('IconFilter', icon.Icon, {
    path: FILTER,
});

exports.IconFilter = IconFilter;
//# sourceMappingURL=index-01a57a6c.js.map
